import React from 'react';

import type { Lease, Property } from '../models';
import { DocumentBackend } from '../models/Types';
import DotloopLeaseUnsupportedToast from '../pages/LandlordLeaseView/ListView/DotloopLeaseUnsupportedToast';
import DocumentModal from '../pages/LandlordLeaseView/SelfServeView/DocumentModal';

type Props = {
  leaseId: number;
  lease?: Lease;
  property?: Property;
  isColandlord?: boolean;
  onClose(): void;
  onError?(error: string): void;
};

export default function DocumentPreviewSelector({ lease, leaseId, property, isColandlord, onClose, onError }: Props) {
  if (lease == null) {
    return null;
  }

  if (lease.documentBackend === DocumentBackend.dotloop) {
    return <DotloopLeaseUnsupportedToast isColandlord={isColandlord} />;
  }

  return <DocumentModal {...{ leaseId, lease, property, isColandlord, onClose, onError }} />;
}
